import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentFallback = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 118,
	height: 91,
	fill: "none",
	viewBox: "0 0 118 91",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#pet__clip0_19475_3050)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M26.4537 90.1717H12.7153C11.8343 90.1725 10.9686 89.9416 10.2053 89.5021C9.44199 89.0626 8.80802 88.43 8.36715 87.6681C7.92628 86.9061 7.69406 86.0416 7.69385 85.1615C7.69364 84.2814 7.92545 83.4168 8.36596 82.6547L12.3931 75.7008L29.871 45.5293L51.3416 8.3809C51.782 7.61954 52.4153 6.98736 53.1777 6.54785C53.9401 6.10833 54.8049 5.87695 55.6852 5.87695C56.5655 5.87695 57.4302 6.10833 58.1927 6.54785C58.9551 6.98736 59.5883 7.61954 60.0288 8.3809L81.4993 45.5293L102.97 82.6777C103.404 83.4384 103.631 84.2995 103.629 85.1752C103.626 86.051 103.394 86.9108 102.955 87.6689C102.516 88.427 101.886 89.057 101.128 89.4962C100.369 89.9353 99.5087 90.1682 98.632 90.1717H34.0708"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M56.4872 56.4169C56.4872 56.625 56.2769 59.0869 56.2535 59.2834V59.3528C55.9911 60.3582 55.3942 61.247 54.5588 61.876C53.7235 62.5051 52.6983 62.8377 51.6485 62.8203C50.6373 62.8169 49.6609 62.4544 48.8972 61.7989C48.1335 61.1434 47.6333 60.2384 47.4876 59.2487L45.5825 30.8958C45.5825 30.7108 45.5825 30.5259 45.5825 30.341C45.581 29.5659 45.734 28.7981 46.0329 28.0816C46.3318 27.365 46.7706 26.7138 47.3243 26.1652C47.8779 25.6166 48.5356 25.1814 49.2595 24.8844C49.9835 24.5874 50.7595 24.4346 51.5433 24.4346C54.8393 24.4346 58.2638 27.0815 58.2638 30.341L56.7911 51.4468L56.4872 56.4169Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M52.1744 79.8228C55.4084 79.8228 58.03 77.2302 58.03 74.032C58.03 70.8338 55.4084 68.2412 52.1744 68.2412C48.9405 68.2412 46.3188 70.8338 46.3188 74.032C46.3188 77.2302 48.9405 79.8228 52.1744 79.8228Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#D8DEE3",
				d: "M108.586 82.7918L108.425 82.5086C107.946 81.5507 107.602 80.8698 107.466 80.5928L96.4336 61.9139L64.437 7.30719C63.2562 5.27016 59.9272 5.47081 58.4361 7.66176L58.1691 8.04836C58.6624 8.06219 59.1442 8.1989 59.5699 8.44584C59.9956 8.69277 60.3514 9.04193 60.6044 9.46099L92.5962 64.3086L100.619 77.47C104.233 84.004 107.466 91.1297 90.5588 90.2516L102.953 90.6507C104.108 90.6507 104.783 90.5649 105.547 90.2516C106.312 89.9383 106.931 89.3599 107.466 88.7349C108.665 87.19 109.385 84.9033 108.586 82.7918Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#D8DEE3",
				d: "M59.2689 58.6939C59.2863 58.8901 59.2863 59.0873 59.2689 59.2834V59.3528C59.007 60.3562 58.4119 61.2436 57.5789 61.8724C56.7459 62.5012 55.7235 62.8351 54.6756 62.8203C53.667 62.8206 52.6926 62.4586 51.9337 61.8017C51.1748 61.1447 50.683 60.2375 50.5498 59.2487L48.5278 30.8958C48.5278 30.7108 48.5278 30.5259 48.5278 30.341C48.5263 29.5659 48.6794 28.7981 48.9782 28.0816C49.2771 27.365 49.7159 26.7138 50.2696 26.1652C50.8232 25.6166 51.4809 25.1814 52.2048 24.8844C52.9288 24.5874 53.7049 24.4346 54.4886 24.4346C57.7846 24.4346 61.2091 27.0815 61.2091 30.341L59.2689 58.6939Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#D8DEE3",
				d: "M55.3536 79.314C58.5876 79.314 61.2092 76.7214 61.2092 73.5232C61.2092 70.3251 58.5876 67.7324 55.3536 67.7324C52.1197 67.7324 49.498 70.3251 49.498 73.5232C49.498 76.7214 52.1197 79.314 55.3536 79.314Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#CFD4DC",
				d: "M11.5315 42.2769C12.0404 42.2769 12.5284 42.075 12.8882 41.7158C13.248 41.3565 13.4502 40.8692 13.4502 40.3611C13.4502 39.853 13.248 39.3657 12.8882 39.0064C12.5284 38.6472 12.0404 38.4453 11.5315 38.4453C11.0226 38.4453 10.5346 38.6472 10.1748 39.0064C9.81494 39.3657 9.61279 39.853 9.61279 40.3611C9.61279 40.8692 9.81494 41.3565 10.1748 41.7158C10.5346 42.075 11.0226 42.2769 11.5315 42.2769Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#CFD4DC",
				d: "M107.172 53.1512C107.602 53.1512 108.015 52.982 108.32 52.6809C108.624 52.3797 108.796 51.9712 108.796 51.5453C108.796 51.1194 108.624 50.711 108.32 50.4098C108.015 50.1086 107.602 49.9395 107.172 49.9395C106.741 49.9395 106.328 50.1086 106.023 50.4098C105.719 50.711 105.548 51.1194 105.548 51.5453C105.548 51.9712 105.719 52.3797 106.023 52.6809C106.328 52.982 106.741 53.1512 107.172 53.1512Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FFB5B5",
				d: "M5.54954 36.9674C6.26433 36.9674 6.96304 36.7576 7.5572 36.3646C8.15137 35.9717 8.61426 35.4132 8.88726 34.7599C9.16026 34.1066 9.2311 33.3879 9.0908 32.6948C8.9505 32.0016 8.60536 31.3652 8.09911 30.8662C7.59286 30.3672 6.94826 30.0279 6.24692 29.8914C5.54558 29.7549 4.81906 29.8273 4.15935 30.0994C3.49964 30.3715 2.9364 30.8311 2.54097 31.42C2.14554 32.0088 1.93569 32.7005 1.93801 33.4074C1.9411 34.3526 2.32297 35.2581 2.99992 35.9254C3.67688 36.5927 4.59373 36.9674 5.54954 36.9674Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#CBD1DC",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.4,
				d: "M112.867 42.2764V50.9683"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#CBD1DC",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.4,
				d: "M108.426 46.5762H117.309"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#778087",
				strokeLinecap: "round",
				strokeMiterlimit: 10,
				strokeWidth: 1.4,
				d: "M20.8746 90.1566H6.19472C5.2514 90.1611 4.32357 89.9195 3.50478 89.4562C2.686 88.993 2.00521 88.3244 1.53108 87.5179C1.05694 86.7114 0.806227 85.7955 0.804211 84.8626C0.802196 83.9298 1.04895 83.0128 1.5196 82.2044L5.84408 74.8532L24.5446 42.8477L47.5345 3.4679C48.0029 2.65846 48.6793 1.98578 49.4951 1.51794C50.311 1.0501 51.2373 0.803711 52.1804 0.803711C53.1234 0.803711 54.0498 1.0501 54.8656 1.51794C55.6814 1.98578 56.3578 2.65846 56.8263 3.4679L79.8278 42.8477L102.853 82.239C103.315 83.0466 103.554 83.9598 103.548 84.8876C103.542 85.8154 103.289 86.7253 102.816 87.5265C102.343 88.3278 101.666 88.9923 100.852 89.4538C100.038 89.9152 99.1159 90.1576 98.1777 90.1566H29.0327"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#778087",
				strokeMiterlimit: 10,
				strokeWidth: 1.4,
				d: "M56.4872 56.4169C56.4872 56.625 56.2769 59.0869 56.2535 59.2834V59.3528C55.9911 60.3582 55.3942 61.247 54.5588 61.876C53.7235 62.5051 52.6983 62.8377 51.6485 62.8203C50.6373 62.8169 49.6609 62.4544 48.8972 61.7989C48.1335 61.1434 47.6333 60.2384 47.4876 59.2487L45.5825 30.8958C45.5825 30.7108 45.5825 30.5259 45.5825 30.341C45.581 29.5659 45.734 28.7981 46.0329 28.0816C46.3318 27.365 46.7706 26.7138 47.3243 26.1652C47.8779 25.6166 48.5356 25.1814 49.2595 24.8844C49.9835 24.5874 50.7595 24.4346 51.5433 24.4346C54.8393 24.4346 58.2638 27.0815 58.2638 30.341L56.7911 51.4468L56.4872 56.4169Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#778087",
				strokeMiterlimit: 10,
				strokeWidth: 1.4,
				d: "M52.1744 79.8228C55.4084 79.8228 58.03 77.2302 58.03 74.032C58.03 70.8338 55.4084 68.2412 52.1744 68.2412C48.9405 68.2412 46.3188 70.8338 46.3188 74.032C46.3188 77.2302 48.9405 79.8228 52.1744 79.8228Z"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "pet__clip0_19475_3050",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 118,
			height: 91,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgPaymentFallback);
export default ForwardRef;
